function darkMode() {
  return {
    isDark: false,

    init() {
      this.isDark = localStorage.getItem("darkMode") === "true";
      this.updateHtmlClass();
    },

    toggleDarkMode() {
      this.isDark = !this.isDark;
      localStorage.setItem("darkMode", this.isDark);
      this.updateHtmlClass();
    },

    updateHtmlClass() {
      if (this.isDark) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
  };
}

export default darkMode;
